// components/Kanban/Kanban.js
import { DndContext, DragOverlay } from "@dnd-kit/core";
import { CircularProgress } from "@mui/material";
import KanbanColumn from "./Column";
import './Kanban.css';
import { useDispatch, useSelector } from 'react-redux';
import { /*createDebouncedSearch, setSearchTerm, applySearch,*/ setLoading, setColumns, setCards, setAllCards, setLocalCards , setActiveId, setUpdateColumns, setIsSelected } from '../../features/ControlPanel/store/userManagement/userManagementSlice';
import { useTranslation } from 'react-i18next';
import { useRef, useState } from "react";
import { useEffect } from "react";
import { useMemo } from "react";

const defaultKanbanConfig = {
    getData: (config, selectedEmployeeAvatar, setters, localCards, cards) => {
        // [TEMPLATE]
    },
    onCardDragEnd: (config, cards, cardId, columns, newColumn) => {
        // [TEMPLATE]
    },
    filterColumns: (columns, searchColumn) => {
        // [TEMPLATE]
    },
    renderItem: (item, setIsSelected, selectedIds, columnIdPrefix) => {
        // [TEMPLATE]
    },
    renderItemFilter: (allItems, handleNew, setIsSelected, selectedIds, columnIdPrefix, currentPage, elementsPerPage) => {
        // [TEMPLATE]
    },
    filterCards: (cards, searchTerm, column) => {
        // [TEMPLATE]
    },
    filterAllCards: (allItems, items, role) => {
        // [TEMPLATE]
    },
    getAllExternalItems: (config, selectedEmployeeAvatar) => {
        // [TEMPLATE]
    },
    onAddItem: (config, cards, card, column) => {
        // [TEMPLATE]
    },
    onDeleteItems: (config, selectedIds, cards, column) => {
        // [TEMPLATE]
    },
    dragOverlayShow: (activeId, cards, setIsSelected, columnIdPrefix) => {
        // [TEMPLATE]
    },
    onDeleteColumn: async (column, columns) => {
        // [TEMPLATE]
    },
};

const Kanban = ({
    config = defaultKanbanConfig,
    sensors,
    searchColumn = "",
    selectedEmployeeAvatar,
    columnIdPrefix = "gestion-admin",
    elementsPerPage = 100,
}) => {
    const { cards, columns, localCards, allCards, activeId, updateColumns, loading } = useSelector((state) => state.userManagement);

    const dispatch = useDispatch();
    const { t } = useTranslation();

    const fetchData = async () => {
        if (config.getData) {
            try {
                const test = await config.getData(config, selectedEmployeeAvatar, {
                    setLoading: (loading) => dispatch(setLoading(loading)),
                    setColumns: (columns) => dispatch(setColumns(columns)),
                    setCards: (cards) => dispatch(setCards(cards)),
                    setLocalCards: (localCards) => dispatch(setLocalCards(localCards)),
                }, localCards, cards);
                console.log("print data test", test[0], test[1]);
                dispatch(setColumns(test[0]));
                dispatch(setCards(test[1]));
                dispatch(setLoading(false));
                dispatch(setUpdateColumns(updateColumns + 1));
            } catch (err) {
                console.error("Can't get data", err);
            }
        }
    };

    const initRef = useRef(false);
    useEffect(() => {
        if (!initRef.current) {
            initRef.current = true;
            fetchData();
        }
    });

    const handleDragStart = (event) => {
        dispatch(setActiveId(event.active.id));
    };

    const handleDragEnd = async (event) => {
        dispatch(setActiveId(null));
        const { active, over } = event;

        if (!over || !config.onCardDragEnd) return;

        const cardId = active.id;
        const newColumn = over.id;

        try {
            const newlocalCards = config.onCardDragEnd(config, cards, cardId, columns, newColumn);
            console.log("test values", newlocalCards);
            await dispatch(setCards(newlocalCards));
            dispatch(setUpdateColumns(updateColumns + 1));
        } catch (error) {
            console.error("User already has the role:", newColumn);
        }
    };

    const filteredColumns = useMemo(() => config.filterColumns ? (
        config.filterColumns(columns, searchColumn)
    ) : (
        columns
    ), [columns, searchColumn]);

    const handleDeleteColumn = async (column) => {
        const success = await config.onDeleteColumn(column);
        if (success) await fetchData();

    }


    const handleDeleteItems = async (config, selectedIds, cards, column) => {
        if (config.onDeleteItems) {
            const res = await config.onDeleteItems(config, selectedIds, cards, column);
            fetchData();
            return res;
        }
    }


    const handleAddItem = async (config, cards, card, column) => {
        if (config.onAddItem) {
            const res = await config.onAddItem(config, cards, card, column);
            fetchData();
            return res;
        }
    }

    return (
        <div className={`${columnIdPrefix}-dialog-containers gestion-admin-dialog-containers`} key={columnIdPrefix}>
            <div className={`${columnIdPrefix}-dialog-closed gestion-admin-dialog-closed`} id={`gestion-admin-dialog-closed`}>
            </div>
            <div className={`${columnIdPrefix}-dialog gestion-admin-dialog`} id={`gestion-admin-dialog`}>
                <DndContext
                    onDragStart={handleDragStart}
                    onDragEnd={handleDragEnd}
                    sensors={sensors}
                >
                    {loading ? (
                        <CircularProgress />
                    ) : (
                        filteredColumns.length > 0 ? updateColumns > 0 && (
                            <>
                                {filteredColumns.map((column) => (
                                    <KanbanColumn
                                        key={column.id}
                                        id={column.id}
                                        title={column.title}
                                        description={column.description}
                                        icon={column.icon}
                                        items={cards}
                                        setItems={(items) => dispatch(setCards(items))}
                                        allItems={allCards}
                                        setAllItems={(allitems) => dispatch(setAllCards(allitems))}
                                        renderItem={config.renderItem}
                                        renderItemFilter={config.renderItemFilter}
                                        filter={(cards, searchTerm) => config.filterCards(cards, searchTerm, column)}
                                        filterAll={(allItems, items, role) => config.filterAllCards(allItems, items, role)}
                                        getAllExternalItems={() => config.getAllExternalItems(config, selectedEmployeeAvatar)}
                                        onAddItem={async (card, cards) => handleAddItem(config, cards, card, column)}
                                        onDeleteItems={async (selectedIds, cards) => handleDeleteItems(config, selectedIds, cards, column)}
                                        onDeleteColumn={config.onDeleteColumn && (() =>handleDeleteColumn(column))}
                                        columnIdPrefix={columnIdPrefix}
                                        elementsPerPage={elementsPerPage}
                                        column={column}
                                    />
                                ))}
                            </>
                        ) : (
                            <div>{t("Nothing found")}</div>
                        )
                    )}
                    <DragOverlay>
                        {activeId && config.dragOverlayShow ? (
                            config.dragOverlayShow(activeId, cards, (id) => dispatch(setIsSelected(id)), columnIdPrefix)
                        ) : (
                            null
                        )}
                    </DragOverlay>
                </DndContext>
            </div>
        </div>
    );
};

export default Kanban;
